import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Loader } from "semantic-ui-react";
import UserActivityList from "../UserActivityDashboardComponents/UserActivityList";
import { getActivityList } from "../../UserDetailActions";

const mapState = (state, ownProps) => {
    return {
        id: ownProps.userId,
        activity: state.userDetail.fetchActivities,
        testAttended: state.userDetail.testAttended,
        loading: state.async.loadingActivities
    };
};

const actions = {
    getActivityList
};

class UserActivityDashboard extends Component {
    state = {
        moreActivities: false,
        loadingInitial: true,
        loadedActivities: [],
        contextRef: {},
        id: this.props.userId
    };

    async componentDidMount() {
        // console.log("componentDidMount() called");
        const { userId } = this.props;
        let next = await this.props.getActivityList(userId);
        console.log("next ", next);
        if (next && next.docs && next.docs.length > 0) {
            this.setState({
                loadedActivities: [...this.props.activity],
                moreActivities: true,
                loadingInitial: false
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        // var onlyInA = this.props.activity.filter(
        //     this.comparer(nextProps.activity)
        // );
        // var onlyInB = nextProps.activity.filter(
        //     this.comparer(this.props.activity)
        // );

        // let result = onlyInA.concat(onlyInB);

        // console.log("comparison ", result);

        // if (this.props.activity !== nextProps.activity) {
        // console.log("props activity ", this.props.activity);
        // console.log("next props activity ", nextProps.activity);
        //     this.setState({
        //         loadedActivities: [
        //             ...this.state.loadedActivities,
        //             ...nextProps.activity
        //         ]
        //     });
        //     console.log("loaded activities ", this.state.loadedActivities);
        // }
        if (this.state.id !== this.props.userId) {
            // console.log("loaded activities ", this.state.loadedActivities);
            // console.log("fetch activities ", this.props.activity);
            this.setState({
                loadedActivities: [],
                id: this.props.userId,
                moreActivities: true
            });
        } //else {
        if (this.props.activity.length === 0) {
            this.setState({
                loadedActivities: [
                    ...this.props.activity,
                    ...nextProps.activity
                ],
                id: this.props.userId,
                moreActivities: true
            });
        } else if (
            this.props.activity &&
            this.props.activity.length > 0 &&
            this.props.activity[this.props.activity.length - 1].testId !==
                nextProps.activity[nextProps.activity.length - 1].testId
        ) {
            this.setState({
                loadedActivities: [
                    ...this.state.loadedActivities,
                    ...nextProps.activity
                ],
                id: this.props.userId
            });
        } else {
            // Do nothing
        }
        //   }
    }

    getNextActivities = async () => {
        // console.log("getNextActivities called");
        const { userId, activity } = this.props;
        let lastActivity = activity && activity[activity.length - 1];
        let next = await this.props.getActivityList(userId, lastActivity);
        if (next && next.docs && next.docs.length <= 4) {
            console.log("dead end");
            this.setState({
                moreActivities: false
            });
        }
    };

    handleContextRef = contextRef => this.setState({ contextRef });

    render() {
        const { loading, profile } = this.props;
        const { moreActivities, loadedActivities } = this.state;
        // console.log("profile ", profile);
        return (
            <Grid>
                <Grid.Column width={16}>
                    {/* <h1>{`${profile.displayName}'s`} recent activity</h1> */}
                    <div ref={this.handleContextRef}>
                        <UserActivityList
                            profile={profile}
                            loading={loading}
                            moreActivities={moreActivities}
                            activities={loadedActivities}
                            getNextActivities={this.getNextActivities}
                        />
                    </div>
                </Grid.Column>

                <Grid.Column width={16}>
                    <Loader active={loading} />
                </Grid.Column>
            </Grid>
        );
    }
}

export default connect(
    mapState,
    actions
)(UserActivityDashboard);
